import React from "react";
import "./Header.css";

function Header() {
  return (
    <div className="contact-section-header">
      <div className="contact-content-header">
        <h1>WE’D LOVE TO HEAR FROM YOU</h1>
        <h3>Luxury Media for Real Estate</h3>
        <p>
          Every project begins with connection. Share the details of your vision
          below and allow us to craft a personalized media experience that
          elevates your property. Alternatively, drop us a line at <a href="mailto:info@fenix360media.com">info@fenix360media.com</a>.
        </p>
      </div>
    </div>
  );
}

export default Header;
